export const STORE_USER_INFO = "STORE_USER_INFO"
export const storeUserInfo = (value) => ({
  type: STORE_USER_INFO,
  payload: value,
})
export const GET_AGREEMENT_CARDS = "GET_AGREEMENT_CARDS"
export const getAgreementCards = () => ({
  type: GET_AGREEMENT_CARDS,
})

export const STORE_AGREEMENT_CARDS = "STORE_AGREEMENT_CARDS"
export const storeAgreementCards = (agreementCards) => ({
  type: STORE_AGREEMENT_CARDS,
  payload: agreementCards,
})

export const STORE_THIRDPARTY_INFO = "STORE_THIRDPARTY_INFO"
export const storeThirdPartyInfo = (thirdPartyInfo) => ({
  type: STORE_THIRDPARTY_INFO,
  payload: thirdPartyInfo,
})

export const GET_THIRDPARTY_INFO = "GET_THIRDPARTY_INFO"
export const getThirdPartyInfo = () => ({
  type: GET_THIRDPARTY_INFO,
})

export const PUT_THIRDPARTY_INFO = "PUT_THIRDPARTY_INFO"
export const putThirdPartyInfo = () => ({
  type: PUT_THIRDPARTY_INFO,
})

export const STORE_NOTICE_AGREEMENT = "STORE_NOTICE_AGREEMENT"
export const storeNoticeAgreement = (noticeAgreement) => ({
  type: STORE_NOTICE_AGREEMENT,
  payload: noticeAgreement,
})

export const GET_NOTICE_AGREEMENT = "GET_NOTICE_AGREEMENT"
export const getNoticeAgreement = () => ({
  type: GET_NOTICE_AGREEMENT,
})

export const PUT_NOTICE_AGREEMENT = "PUT_NOTICE_AGREEMENT"
export const putNoticeAgreement = () => ({
  type: PUT_NOTICE_AGREEMENT,
})

export const STORE_IS_API_LOADING = "STORE_IS_API_LOADING"
export const storeApiLoading = (state) => ({
  type: STORE_IS_API_LOADING,
  payload: state,
})
export const SET_CLOSE_SNACKBAR = "SET_CLOSE_SNACKBAR"
export const setCloseSnackbar = () => ({
  type: SET_CLOSE_SNACKBAR,
})

export const SET_SUCCESS = "SET_SUCCESS"
export const setSuccess = (payload) => ({
  type: SET_SUCCESS,
  payload,
})

export const SET_ERROR = "SET_ERROR"
export const setError = (payload) => ({
  type: SET_ERROR,
  payload,
})

export const SET_NOT_FOUND = "SET_NOT_FOUND"
export const setNotFound = (payload) => ({
  type: SET_NOT_FOUND,
  payload,
})

export const SET_LOGOUT = "SET_LOGOUT"
export const setLogout = (payload) => ({
  type: SET_LOGOUT,
  payload,
})

export const STORE_IS_AUTHENTICATION = "STORE_IS_AUTHENTICATION"
export const storeIsAuthentication = (payload) => ({
  type: STORE_IS_AUTHENTICATION,
  payload,
})

export const STORE_IS_AUTH_LOADING = "STORE_IS_AUTH_LOADING"
export const storeIsAuthLoading = (payload) => ({
  type: STORE_IS_AUTH_LOADING,
  payload,
})

export const STORE_INFORMATION = "STORE_INFORMATION"
export const storeInformation = (info) => ({
  type: STORE_INFORMATION,
  payload: info,
})

export const GET_LOCALE_AGREEMENT = "GET_LOCALE_AGREEMENT"
export const getLocaleAgreement = () => ({
  type: GET_LOCALE_AGREEMENT,
})

export const STORE_LOCALE_AGREEMENT = "STORE_LOCALE_AGREEMENT"
export const storeLocaleAgreement = (localeAgreement) => ({
  type: STORE_LOCALE_AGREEMENT,
  payload: localeAgreement,
})

export const PUT_LOCALE_AGREEMENT = "PUT_LOCALE_AGREEMENT"
export const putLocaleAgreement = (localeAgreement) => ({
  type: PUT_LOCALE_AGREEMENT,
  payload: localeAgreement,
})

export const STORE_LOCATION_MODAL_IS_OPEN = "STORE_LOCATION_MODAL_IS_OPEN"
export const storeLocationModalIsOpen = (locationModalIsOpen) => ({
  type: STORE_LOCATION_MODAL_IS_OPEN,
  payload: locationModalIsOpen,
})

export const GET_USER_AGREEMENTS_STATUS = "GET_USER_AGREEMENTS_STATUS"
export const getUserAgreementsStatus = () => ({
  type: GET_USER_AGREEMENTS_STATUS,
})

export const STORE_USER_AGREEMENTS_STATUS = "STORE_USER_AGREEMENTS_STATUS"
export const storeUserAgreementsStatus = (agree) => ({
  type: STORE_USER_AGREEMENTS_STATUS,
  payload: agree,
})

export const STORE_OVERALL_AGREEMENTS = "STORE_OVER_ALL_AGREEMENTS"
export const storeOverallAgreements = (overallAgreements) => ({
  type: STORE_OVERALL_AGREEMENTS,
  payload: overallAgreements,
})

export const STORE_TOP_AGREEMENT_IS_OPEN = "STORE_TOP_AGREEMENT_IS_OPEN"
export const storeTopAgreementsDialogIsOpen = (isOpen) => ({
  type: STORE_TOP_AGREEMENT_IS_OPEN,
  payload: isOpen,
})

export const PUT_OVERALL_AGREEMENTS = "PUT_OVERALL_AGREEMENTS"
export const putOverallAgreements = () => ({
  type: PUT_OVERALL_AGREEMENTS,
})
